import ax from "axios";
import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Body, Overlay, Title } from "@components";
import { Update } from "mdi-material-ui";
import { Button } from "@material-ui/core";
import { useGlobalStore } from "@hooks";

export const OutdatedOverlay = observer(() => {
  const store = useGlobalStore();
  const [_, setForceUpdate] = React.useState(0);

  const poll = () => {
    ax.head("/api/poll")
      .then((res) => {
        store.setMinVersion(res.headers["x-gw-min-ver"]);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setForceUpdate((prev) => prev + 1);
      });
  };

  useEffect(() => {
    setInterval(() => poll(), 60000);
  }, []);

  if (!store.shouldUpdate) {
    return null;
  }

  return (
    <Overlay in style={{ backgroundColor: "#808080b3", zIndex: 9999 }}>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "white",
            marginLeft: -43
          }}
        >
          <Update fontSize="large" style={{ marginRight: 8 }} />
          <Title>En ny version finns tillgänglig</Title>
        </div>

        <div style={{ maxWidth: "30rem", marginTop: 16 }}>
          <Body style={{ color: "white", fontWeight: 600 }}>
            Det finns en ny version av CRM tillgänglig. Om du fortsätter jobba i nuvarande
            version kommer viss funktionalitet inte fungera korrekt. Vi rekommenderar att
            du refreshar din webbläsare men säkerställ först att alla ändringar är
            sparade. Tryck på påminn ifall du har något att spara först.
          </Body>
        </div>

        <div style={{ marginTop: 24, display: "flex" }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => window.location.reload()}
          >
            Refresha och Uppdatera
          </Button>

          <Button
            style={{ marginLeft: 8 }}
            variant="contained"
            onClick={() => store.snoozeUpdate(5)}
          >
            Påminn om 5 minuter
          </Button>
        </div>
      </div>
    </Overlay>
  );
});
